const { setCSRFToken } = require("../components/utils");
const { showMiniCartError } = require("../components/cartHelper");

export function setBadgeColors() {
    const $colors = $("#product-badge-colors");
    const $tagBadge = $(".tag-badge");
    const $tagBadgeLink = $tagBadge.find(".tag-badge-item");
    const backgroundColor = $colors.data("background-color");
    const fontColor = $colors.data("font-color");

    $tagBadge.css("background-color", backgroundColor).css("color", fontColor);
    $tagBadgeLink.css("color", fontColor);
}

export async function getRedirectionUrl(productUrl, pid) {
    // ensure redirect URL is provided
    if (productUrl) {
        return productUrl;
    }

    // if redirect URL is not provided and PID is, redirect get product URL by PID and redirect
    if (pid) {
        var response = await $.ajax({
            url: window.Resources.PRODUCT_URL,
            method: "POST",
            data: {
                pid: pid,
                csrf_token: $("[name=csrf_token]").val()
            }
        });
        if (response && response.url) {
            return response.url;
        }
    }

    // if redirect URL is not provided and PID is not, redirect Home Page
    return window.Resources.HOME_URL;
}

export default function () {
    $(document).on("click", ".producttile-add-to-cart", async function (e) {
        e.preventDefault();

        const $this = $(this);
        const addToCartUrl = $this.data("url");
        const pid = $this.data("pid");
        const productDetailURL = await getRedirectionUrl($this.data("pdp-url"), pid);
        const pidsObj = $this.attr("data-pidsobj") || "";
        const isEnabledProductTileButtons = $this.data("is-enabled-producttile-buttons");
        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: "",
            quantity: 1,
            isProductTile: true,
            csrf_token: ""
        };

        if (isEnabledProductTileButtons) {
            var isForcedOutOfStock = $this.data("is-forced-out-of-stock");
            var isRedirectUrl = $this.data("is-redirect-url");

            if (isForcedOutOfStock || isRedirectUrl) {
                window.location.href = productDetailURL;
                return;
            }

            if ($this.find(".add-to-cart-btn").length) {
                $.spinner().start();
            }
        }

        setCSRFToken().then(function(dataToken) {
            form.csrf_token = dataToken.csrf.token;
            makeAddToCartAjaxCall(addToCartUrl, form, productDetailURL);
        });
    });

    $(document).on("mouseover", ".js-img-container", function() {
        const $hoverImg = $(this).find(".js-hover-img");

        if ($hoverImg.length > 0 && !$hoverImg.hasClass("lazyloaded")) {
            $hoverImg.attr("src", $hoverImg.data("src")).addClass("lazyloaded");
        }
    });

    setBadgeColors();
}

/**
 * Makes Ajax call for adding the product to Cart
 * @param {String} addToCartUrl
 * @param {Object} form
 * @param {String} productDetailURL
 */
function makeAddToCartAjaxCall(addToCartUrl, form, productDetailURL) {
    $.ajax({
        url: addToCartUrl,
        method: "POST",
        data: form,
        success: function (data) {
            var orderCapLimited = data.orderCapLimited || false;

            if (data && data.error && !orderCapLimited) {
                $.spinner().stop();
                window.location.href = productDetailURL;
            } else {
                $("body").trigger("product:afterAddToCart", data);
                handlePostCartAdd(data);
                $.spinner().stop();
                miniCartReportingUrl(data.reportingURL);

                if ($(".page").data("action") === "Cart-Show") {
                    window.location.reload();
                }
            }
        },
        error: function () {
            window.location.href = productDetailURL;
            return;
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {Object} response - ajax response from clicking the add to cart button
 */
var timer;
function handlePostCartAdd(response) {
    const $minicart = $(".minicart");
    const $header = $(".page-header");
    const $minicartPopover = $header.find(".minicart-popover");
    const messageType = response.error ? "alert-danger" : "alert-success";

    clearTimeout(timer);
    $minicart.trigger("count:update", response);

    // show minicart
    $minicart.find(".minicart-total").click();
    var $addToCartMsg = $(".add-to-cart-messages");

    if ($addToCartMsg.length === 0) {
        $("body").append(
            "<div class=\"add-to-cart-messages\"></div>"
        );
    }

    $(".add-to-cart-messages")
        .empty()
        .append(
            "<div class=\"alert " + messageType + " add-to-basket-alert text-center\" role=\"alert\">"
            + response.message
            + "</div>"
        );

    var observer = new MutationObserver(function () {
        if (response && response.error) {
            showMiniCartError($minicartPopover, response.message);
        }
    });

    observer.observe($minicartPopover[0], {childList: true});

    timer = setTimeout(function () {
        $minicartPopover.find(".minicart-close-button").click();
        $minicartPopover.find(".valid-cart-error").empty();
        observer.disconnect();
    }, 5000);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
export function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}
